/**
 * Product scene clips, how-it-works clips and the homepage hero loop (video + poster) are
 * rendered in German and English (`X.mp4` and `X-en.mp4`). German pages get
 * the German cut; every other language gets the English one. Both hero loops have a full-length cut with sound (`heyfinn-intro-full`).
 */
const LOCALIZED =
  /^\/(videos\/landing\/(SceneClip-|HowItWorks-|heyfinn-intro(-full)?\.)|images\/hero-poster\.)/;

/** German pages (and an unknown language) get the German cut. */
export function usesGermanCut(language?: string): boolean {
  return !language || language.startsWith("de");
}

export function localizedClipSrc(src: string, language?: string): string {
  if (usesGermanCut(language) || !LOCALIZED.test(src)) {
    return src;
  }
  return src.replace(/\.(mp4|webp)$/, "-en.$1");
}
